import { Component, inject, input } from '@angular/core';
import { AsyncPipe, CommonModule, NgOptimizedImage } from '@angular/common';
import { PipesModule } from '@/modules/shared/pipes/pipes.module';
import { OfferList } from '@/_store/offers/offers.types';
import { MainService } from '@/main/services/main.service';
import { OffersFacade } from '@/_store/offers/offers.facade';

@Component({
	selector: 'app-offer-box-mobile',
	templateUrl: './offer-box-mobile.component.html',
	standalone: true,
	imports: [CommonModule, NgOptimizedImage, PipesModule, AsyncPipe],
})
export class OfferBoxMobileComponent {
	readonly offer = input.required<OfferList>();
	readonly mainService = inject(MainService);
	readonly offersFacade = inject(OffersFacade);
}
